import 'purecss';
import 'purecss/build/grids-responsive-min.css';
import '@babel/polyfill';

import 'image-compare-viewer/dist/image-compare-viewer.min.css';
import 'lightbox2/dist/css/lightbox.min.css';

import '../scss/style.scss';

import $ from 'jquery';
import 'lightbox2';
import ImageCompare from 'image-compare-viewer';

$(() => {
  $(window).on('load scroll', () => {
    $('.animation').each(function () {
      const target = $(this).offset().top;
      const scroll = $(window).scrollTop();
      const height = $(window).height() - 100;
      if (scroll > target - height) {
        $(this).addClass('active');
      }
    });
  });

  const element = document.getElementById('image-compare');
  const options = {
    controlColor: '#fff',
    controlShadow: false,
    addCircle: true,
    addCircleBlur: true, // default
  };
  const viewer = new ImageCompare(element, options).mount();
});
